/* FIRSTMILE CAR CARE theme - vanilla JS. Every price, currency and availability value comes from
   Shopify (cart API + section rendering), nothing is computed or hardcoded here. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var $ = function (selector, context) { return (context || document).querySelector(selector); };
  var $$ = function (selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); };

  /* ---------- Header offset (mobile menu) ---------- */
  function setHeaderOffset() {
    var header = $('[data-header]');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--header-offset', Math.max(0, Math.round(bottom)) + 'px');
  }

  /* ---------- Mobile menu ---------- */
  function setMenu(open) {
    var toggle = $('[data-menu-toggle]');
    var menu = $('[data-mobile-menu]');
    if (!toggle || !menu) return;
    setHeaderOffset();
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('has-overlay', open);
  }

  /* ---------- Cart drawer ---------- */
  var lastFocus = null;

  function drawer() { return $('[data-cart-drawer]'); }

  function openDrawer() {
    var el = drawer();
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('has-overlay');
    var panel = $('.cart-drawer__panel', el);
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('has-overlay');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = $('[data-cart-drawer-content]', doc);
      var current = $('[data-cart-drawer-content]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          var error = new Error(data.description || data.message || theme.strings.cartError);
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    var row = $('[data-line="' + line + '"].cart-line');
    if (row) row.classList.add('is-updating');
    var onCartPage = !!$('#CartForm');
    var body = { line: Number(line), quantity: Number(quantity) };
    if (!onCartPage) body.sections = 'cart-drawer';
    return cartRequest(theme.routes.cartChange + '.js', body)
      .then(function (cart) {
        if (onCartPage) { window.location.reload(); return; }
        updateCartCount(cart.item_count);
        renderCartSections(cart.sections);
      })
      .catch(function () {
        if (row) row.classList.remove('is-updating');
      });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(renderCartSections);
  }

  /* ---------- Product forms (product page + homepage featured product) ---------- */
  function initProduct(root) {
    var form = $('[data-type="add-to-cart-form"]', root);
    if (!form || form.__fmReady) return;
    form.__fmReady = true;

    var variantsScript = $('[data-variants-json]', root);
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var idInput = $('[data-variant-id]', form);
    var addButton = $('[data-add-to-cart]', form);
    var buyButton = $('[data-buy-now]', form);
    var errorEl = $('[data-product-error]', form);
    var priceWrap = $('[data-price-wrap]', root);
    var availWrap = $('[data-availability-wrap]', root);
    var updateUrl = root.hasAttribute('data-update-url');

    function selectedOptions() {
      var values = [];
      $$('.option__input:checked', form).forEach(function (input) {
        values[Number(input.getAttribute('data-option-index'))] = input.value;
      });
      return values;
    }

    function setLabel(button, text) {
      var label = $('[data-label]', button) || $('span', button);
      if (label) label.textContent = text;
    }

    function showMedia(variant) {
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      var target = mediaId && $('[data-media-id="' + mediaId + '"]', root);
      var gallery = $('.gallery', root);
      if (!target || !gallery) return;
      if (gallery.scrollWidth > gallery.clientWidth && getComputedStyle(gallery).display === 'flex') {
        gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      } else if (updateUrl) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function applyVariant() {
      if (!variants.length) return;
      var chosen = selectedOptions();
      var variant = variants.filter(function (v) {
        return v.options.every(function (value, index) { return value === chosen[index]; });
      })[0];

      if (!variant) {
        addButton.disabled = true;
        if (buyButton) buyButton.disabled = true;
        setLabel(addButton, theme.strings.unavailable);
        if (availWrap) availWrap.textContent = theme.strings.unavailable;
        return;
      }

      idInput.value = variant.id;
      if (errorEl) errorEl.hidden = true;
      addButton.disabled = !variant.available;
      if (buyButton) buyButton.disabled = !variant.available;
      setLabel(addButton, variant.available ? theme.strings.addToCart : theme.strings.soldOut);
      if (availWrap) availWrap.textContent = variant.available ? theme.strings.inStock : theme.strings.soldOut;

      /* Prices are rendered by Shopify for each variant (market currency, rounding, taxes). */
      var template = $('[data-variant-price="' + variant.id + '"]', form);
      if (template && priceWrap) priceWrap.innerHTML = template.innerHTML;

      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      showMedia(variant);
    }

    form.addEventListener('change', function (event) {
      if (event.target.classList.contains('option__input')) applyVariant();
    });

    function addToCart(button, afterAdd) {
      if (!button || button.disabled) return;
      button.disabled = true;
      button.classList.add('is-loading');
      if (errorEl) errorEl.hidden = true;

      var useDrawer = theme.cartType === 'drawer' && !!drawer() && !afterAdd;
      var body = {
        items: [{
          id: Number(idInput.value),
          quantity: Number($('[data-qty-input]', form).value) || 1
        }]
      };
      if (useDrawer) {
        body.sections = 'cart-drawer';
        body.sections_url = window.location.pathname;
      }

      cartRequest(theme.routes.cartAdd + '.js', body)
        .then(function (response) {
          if (afterAdd) { afterAdd(); return; }
          if (!useDrawer) { window.location.href = theme.routes.cart; return; }
          renderCartSections(response.sections);
          return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateCartCount(cart.item_count);
            button.classList.add('is-added');
            setLabel(button, theme.strings.added);
            openDrawer();
            window.setTimeout(function () {
              button.classList.remove('is-added');
              setLabel(button, theme.strings.addToCart);
            }, 1800);
          });
        })
        .catch(function (error) {
          if (errorEl) {
            errorEl.textContent = error.message || theme.strings.addError;
            errorEl.hidden = false;
          }
        })
        .then(function () {
          button.classList.remove('is-loading');
          applyVariant();
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addToCart(addButton);
    });

    if (buyButton) {
      buyButton.addEventListener('click', function () {
        addToCart(buyButton, function () { window.location.href = theme.routes.checkout; });
      });
    }

    initGallery(root);
  }

  /* Mobile photo slider: dots show the position, photos glide and fade while swiping */
  function initGallery(root) {
    var gallery = $('.gallery', root);
    if (!gallery || gallery.__fmGallery) return;
    gallery.__fmGallery = true;
    var items = $$('.gallery__item', gallery);
    var dots = $$('[data-gallery-dot]', root);
    var animate = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var ticking = false;

    function isSlider() { return gallery.scrollWidth > gallery.clientWidth + 2; }

    function update() {
      ticking = false;
      if (!isSlider()) {
        items.forEach(function (item) { item.style.removeProperty('--p'); item.style.removeProperty('--a'); });
        return;
      }
      var width = gallery.clientWidth || 1;
      var box = gallery.getBoundingClientRect();
      var position = gallery.scrollLeft / width; /* fractional index of the photo currently in view */
      var active = Math.max(0, Math.min(items.length - 1, Math.round(position)));
      /* Dots follow the scroll continuously: the nearest dot stretches and brightens, the others shrink back */
      dots.forEach(function (dot, index) {
        var strength = Math.max(0, 1 - Math.abs(index - position));
        dot.style.setProperty('--d', strength.toFixed(3));
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
      if (!animate) return;
      items.forEach(function (item) {
        var p = Math.max(-1, Math.min(1, (item.getBoundingClientRect().left - box.left) / width));
        item.style.setProperty('--p', p.toFixed(3));
        item.style.setProperty('--a', Math.abs(p).toFixed(3));
      });
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    gallery.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        gallery.scrollTo({ left: items[index].offsetLeft, behavior: animate ? 'smooth' : 'auto' });
      });
    });
    update();
  }

  /* ---------- Product recommendations ---------- */
  var ProductRecommendations = typeof HTMLElement !== 'undefined' ? class extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (!url || this.getAttribute('data-loaded')) return;
      this.setAttribute('data-loaded', 'true');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = $('product-recommendations', doc);
          if (fresh && fresh.innerHTML.trim().length) this.innerHTML = fresh.innerHTML;
        }.bind(this));
    }
  } : null;
  if (ProductRecommendations && !customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target;

    var menuToggle = target.closest('[data-menu-toggle]');
    if (menuToggle) {
      setMenu(menuToggle.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var cartOpen = target.closest('[data-cart-open]');
    if (cartOpen && theme.cartType === 'drawer' && drawer()) {
      event.preventDefault();
      refreshDrawer().then(openDrawer);
      return;
    }

    if (target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }

    var qtyChange = target.closest('[data-qty-change]');
    if (qtyChange) {
      changeLine(qtyChange.getAttribute('data-line'), qtyChange.getAttribute('data-qty-change'));
      return;
    }

    var qtyStep = target.closest('[data-qty-step]');
    if (qtyStep) {
      var input = $('[data-qty-input]', qtyStep.closest('[data-qty]'));
      var next = (Number(input.value) || 1) + Number(qtyStep.getAttribute('data-qty-step'));
      input.value = Math.max(Number(input.min) || 1, next);
      return;
    }

    /* Close the search panel when clicking elsewhere */
    var search = $('[data-search-details][open]');
    if (search && !target.closest('[data-search-details]')) search.removeAttribute('open');

    /* Close the locale panel when clicking elsewhere */
    $$('[data-locale-details][open]').forEach(function (details) {
      if (!details.contains(target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('change', function (event) {
    var target = event.target;

    if (target.matches('[data-qty-input][data-line]')) {
      changeLine(target.getAttribute('data-line'), target.value);
      return;
    }

    /* Switching language submits the Shopify localization form straight away */
    if (target.matches('[data-locale-select]') && target.name === 'language_code' && target.form) {
      target.form.submit();
      return;
    }

    /* Auto-submit sorting/filtering */
    var autoForm = target.closest('form[data-auto-submit]');
    if (autoForm && !target.closest('.toolbar__panel')) autoForm.submit();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeDrawer();
    setMenu(false);
    $$('[data-locale-details][open], [data-search-details][open]').forEach(function (el) { el.removeAttribute('open'); });
  });

  window.addEventListener('resize', function () {
    setHeaderOffset();
    if (window.innerWidth >= 990) setMenu(false);
  });

  /* ---------- Motion: header, reveal, parallax, product story ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var visibleParallax = [];
  var parallaxTicking = false;

  function updateScrollState() {
    document.documentElement.classList.toggle('is-scrolled', window.scrollY > 40);
  }

  function runParallax() {
    parallaxTicking = false;
    var vh = window.innerHeight || 1;
    visibleParallax.forEach(function (item) {
      var rect = item.el.parentElement.getBoundingClientRect();
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh; /* -1..1 around the viewport centre */
      var shift = Math.max(-1, Math.min(1, progress)) * item.speed * -100;
      item.el.style.transform = 'translate3d(0,' + shift.toFixed(2) + '%,0) scale(1.12)';
    });
  }

  function requestParallax() {
    if (parallaxTicking || !visibleParallax.length) return;
    parallaxTicking = true;
    window.requestAnimationFrame(runParallax);
  }

  function initMotion(scope) {
    var root = scope || document;
    var targets = $$('[data-reveal]', root);
    var parallaxEls = $$('[data-parallax]', root);
    var story = $$('[data-story]', root);

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      story.forEach(initStoryStatic);
      return;
    }

    if (!window.__fmRevealObserver) {
      window.__fmRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            window.__fmRevealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      window.__fmParallaxObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          var index = visibleParallax.findIndex(function (item) { return item.el === el; });
          if (entry.isIntersecting && index === -1) {
            visibleParallax.push({ el: el, speed: Number(el.getAttribute('data-parallax')) || 0.06 });
          } else if (!entry.isIntersecting && index !== -1) {
            visibleParallax.splice(index, 1);
          }
        });
        requestParallax();
      }, { rootMargin: '10% 0px 10% 0px' });
    }

    targets.forEach(function (el) { window.__fmRevealObserver.observe(el); });
    parallaxEls.forEach(function (el) { window.__fmParallaxObserver.observe(el); });
    story.forEach(initStory);
  }

  function setActive(section, index) {
    $$('[data-frame]', section).forEach(function (el) {
      el.classList.toggle('is-active', Number(el.getAttribute('data-frame')) === index);
    });
    $$('[data-step]', section).forEach(function (el) {
      el.classList.toggle('is-active', Number(el.getAttribute('data-step')) === index);
    });
  }

  function initStoryStatic(section) {
    $$('[data-step]', section).forEach(function (step) {
      step.addEventListener('click', function () { setActive(section, Number(step.getAttribute('data-step'))); });
    });
  }

  function initStory(section) {
    if (section.__fmStory) return;
    section.__fmStory = true;
    var steps = $$('[data-step]', section);
    if (!steps.length) return;

    /* A step becomes active when it crosses a band of the viewport (below the sticky stage on mobile, centred on desktop). */
    var desktop = window.matchMedia('(min-width: 990px)');
    var observer;

    function build() {
      if (observer) observer.disconnect();
      var margin = desktop.matches ? '-45% 0px -45% 0px' : '-64% 0px -26% 0px';
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(section, Number(entry.target.getAttribute('data-step')));
        });
      }, { rootMargin: margin, threshold: 0 });
      steps.forEach(function (step) { observer.observe(step); });
    }

    build();
    if (desktop.addEventListener) desktop.addEventListener('change', build);
    initStoryStatic(section);
  }

  window.addEventListener('scroll', function () {
    updateScrollState();
    requestParallax();
  }, { passive: true });

  /* Smooth in-page links (respect reduced motion) */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-scroll-to]');
    if (!link) return;
    var target = $(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Init ---------- */
  function init() {
    setHeaderOffset();
    updateScrollState();
    $$('[data-product-section]').forEach(initProduct);
    initMotion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-initialise sections when they are reloaded */
  document.addEventListener('shopify:section:load', function (event) {
    $$('[data-product-section]', event.target).forEach(initProduct);
    $$('[data-reveal]', event.target).forEach(function (el) { el.classList.add('is-in'); });
    initMotion(event.target);
    setHeaderOffset();
  });
})();

/* sync */
